import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";
import { ShimmerPostList } from "react-shimmer-effects";
import { getMachineGroup } from "../../../actions/machine-group/machine-group";
import MachineGroupListComponent from "../../../components/Definition/MachineGroup/MachineGroupListComponent";
import PeymankarListComponent from "../../../components/Definition/Peymankar/PeymankarListComponent";
import { deletePeymankar, getPeymankar } from "../../../actions/peymankar/peymankar";
import { deleteJensCode } from "../../../actions/reports/jens_codes";

export default function Peymankar() {
    const [peymankar, setPeymankar] = useState({ data: [], links: {} });
    const [loading, setLoading] = useState(true);
    const [status, setStatusDelete] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        setLoading(true);
        const fetchApi = async () => {
            const params = new URLSearchParams(searchParams);
            try {
                const usersData = await getPeymankar({page:params.toString()});
                setLoading(false);
                setPeymankar(usersData.status !== "error" ? usersData.message : { data: [], links: {} });
            } catch (error) {
                toast.error('خطا در اتصال به سرور!');
                setLoading(false);
            }
        };

        fetchApi();
    }, [searchParams,status]);

    return (
        <DashboardLayout>
            {loading ? <ShimmerPostList postStyle="STYLE_THREE" col={1} row={3} gap={30} /> : <PeymankarListComponent lists={peymankar} deleteInvoke={async(id)=>{
                const prompt = window.confirm("آیا میخواهید پیمانکار حذف شود ؟ با این کار گزارشات وابسته از بین خواهد رفت")
                if(prompt){
                    const response = await deletePeymankar(id);
                    if (response.status === "success") {
                        toast.success("پیمانکار حذف شد!");
                        setStatusDelete(true);
                    } else {
                        toast.error("خطا در حذف گروه پیمانکار");
                    }
                }
            }} />}
        </DashboardLayout>
    );
}
